import { useUserDatabase } from "../contexts/UserDatabaseContext";
import MKBox from "components/MKBox";
import MKAvatar from "components/MKAvatar";
import MKTypography from "components/MKTypography";
import PropTypes from "prop-types";
import MKBadge from "components/MKBadge";
import { useState, useEffect } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Table from "../components/Table";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";

function User({ photoUrl, name, email }) {
  return (
    <MKBox display="flex" alignItems="center" px={1} py={0.5}>
      <MKBox mr={2}>
        <MKAvatar src={photoUrl} alt={name} size="sm" variant="rounded" />
      </MKBox>
      <MKBox display="flex" flexDirection="column">
        <MKTypography variant="button" fontWeight="medium">
          {name}
        </MKTypography>
        <MKTypography variant="caption" color="secondary">
          {email}
        </MKTypography>
      </MKBox>
    </MKBox>
  );
}

User.propTypes = {
  photoUrl: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
};

function CreatedAt({ createdAt }) {
  return (
    <MKTypography variant="caption" color="secondary">
      {new Date(createdAt).toLocaleDateString("nl-NL", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })}
    </MKTypography>
  );
}

CreatedAt.propTypes = {
  createdAt: PropTypes.string.isRequired,
};

function HasAcceptedTerms({ hasAcceptedTerms }) {
  let color;
  if (hasAcceptedTerms) {
    color = "success";
  } else {
    color = "warning";
  }

  return (
    <MKBadge
      variant="contained"
      badgeContent={hasAcceptedTerms ? "Ja" : "Nee"}
      color={color}
      size="xs"
      container
    />
  );
}

HasAcceptedTerms.propTypes = {
  hasAcceptedTerms: PropTypes.bool.isRequired,
};

function IsAdmin({ isAdmin }) {
  let color;
  if (isAdmin) {
    color = "info";
  } else {
    color = "success";
  }

  return (
    <MKBadge
      variant="contained"
      badgeContent={isAdmin ? "Ja" : "Nee"}
      color={color}
      size="xs"
      container
    />
  );
}

IsAdmin.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
};

function UserDatabaseList() {
  const { fetchedUsers, loading } = useUserDatabase();
  const navigate = useNavigate();
  const columns = [
    { name: "gebruiker", align: "left" },
    { name: "aangemaakt op", align: "center" },
    // { name: "voorwaarden geaccepteerd", align: "center" },
    { name: "admin", align: "center" },
  ];
  const [rows, setRows] = useState([]);

  const handleRowClick = (rowIndex) => {
    const user = fetchedUsers[rowIndex];

    console.log(user);
    navigate(`/admin/user-database/${user.id}`);
  };

  useEffect(() => {
    if (fetchedUsers.length > 0) {
      setRows(
        fetchedUsers.map((user) => ({
          gebruiker: <User photoUrl={user.photoUrl} name={user.displayName} email={user.email} />,
          "aangemaakt op": <CreatedAt createdAt={user.createdAt} />,
          // "voorwaarden geaccepteerd": <HasAcceptedTerms hasAcceptedTerms={user.hasAcceptedTerms} />,
          admin: <IsAdmin isAdmin={user.admin} />,
        }))
      );
    }
  }, [fetchedUsers]);

  if (loading) {
    return (
      <MKBox component="section" py={24} display="flex" justifyContent="center" alignItems="center">
        <CircularProgress size={40} />
      </MKBox>
    );
  }

  return (
    <MKBox component="section" py={3}>
      <Container>
        <Grid container item xs={12} lg={10} mx="auto">
          <Table columns={columns} rows={rows} onRowClick={handleRowClick} />
        </Grid>
      </Container>
    </MKBox>
  );
}

export default UserDatabaseList;
